const BASE_URL = process.env.BASE_URL || "/";

export const excelTemplate = {
  Borrowers: BASE_URL + 'static/Excel-template/borrowers-YYYYMMDD0001.xlsx',
  Sureties: BASE_URL + 'static/Excel-template/sureties-YYYYMMDD0001.xlsx',

  Contracts: BASE_URL + 'static/Excel-template/contracts-YYYYMMDD0001.xlsx',
  ContractsSureties: BASE_URL + 'static/Excel-template/contractsSureties-YYYYMMDD0001.xlsx',
  LoanDetails: BASE_URL + 'static/Excel-template/loanDetails-YYYYMMDD0001.xlsx',
  LoanDetailPlans: BASE_URL + 'static/Excel-template/loanDetailPlans-YYYYMMDD0001.xlsx',
  Payments: BASE_URL + 'static/Excel-template/payments-YYYYMMDD0001.xlsx',
  TrackDownDebts: BASE_URL + 'static/Excel-template/trackDownDebts-YYYYMMDD0001.xlsx',
  BadDebts: BASE_URL + 'static/Excel-template/badDebts-YYYYMMDD0001.xlsx',
  ContractIndexes: BASE_URL + 'static/Excel-template/contractIndexes-YYYYMMDD0001.xlsx',

  // GeneratesQrCode: BASE_URL + 'static/Excel-template/generatesQrCode-YYYYMMDD0001.xlsx',
  // ContractsRestructuring: BASE_URL + 'static/Excel-template/contractsRestructuring-YYYYMMDD0001.xlsx',
  // ContractsInterestRateEir: BASE_URL + 'static/Excel-template/contractsInterestRateEir-YYYYMMDD0001.xlsx',
  // ContractsForecastDate: BASE_URL + 'static/Excel-template/contractsForecastDate-YYYYMMDD0001.xlsx',
  // ContractsAccoNo: BASE_URL + 'static/Excel-template/contractsAccoNo-YYYYMMDD0001.xlsx',
  // SuretiesUpdate: BASE_URL + 'static/Excel-template/suretiesUpdate-YYYYMMDD0001.xlsx',
  // BorrowersUpdate: BASE_URL + 'static/Excel-template/borrowersUpdate-YYYYMMDD0001.xlsx',
  // PaymentsByContractNo: BASE_URL + 'static/Excel-template/payments-{ContractNo}.xlsx',
};
